import { useEffect, useState } from 'react';

const useWidth = ref => {
  const [width, setWidth] = useState();
  useEffect(() => {
    if (!width) {
      setWidth(ref.current.offsetWidth);
    }
    function onResize() {
      setWidth(ref.current.offsetWidth);
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [ref, width]);
  return width;
};

export default useWidth;
